// Опознаёт системный аккаунт (бот системных сообщений). Бэк отдаёт его как
// ASMSYSTEMBOT; исторически сравнивали с числовым id 0. Матчим и по id, и по имени.
// 1:1 с приложением (core/common/constants isSystemAccountMatch).
const SYSTEM_ACCOUNT_MARKER = "ASMSYSTEMBOT";

export const isSystemAccount = (idOrName?: string | number | null): boolean => {
  if (idOrName === undefined || idOrName === null) return false;
  const value = String(idOrName).toUpperCase();
  return value === "0" || value === SYSTEM_ACCOUNT_MARKER;
};

export default isSystemAccount;
